export default __webpack_public_path__ + "static/media/Mis eventos.fbf472b8.png";